import clsx from "clsx";

import { plural } from "../shared/format";

/** The most beads drawn for one hand-over; the rest are counted in words. */
export const MAX_BEADS = 40;

interface BeadsProps {
  /** How many cards the hand-over holds. */
  total: number;
  /** How many of them are Unsure (they come first). */
  unsure?: number;
  className?: string;
}

/** One small bead for each card of a hand-over; the Unsure ones come first and are drawn hollow. */
export function Beads({ total, unsure = 0, className }: BeadsProps) {
  const shown = Math.min(total, MAX_BEADS);
  const hollow = Math.min(unsure, shown);
  const label = `${plural(total, "card")}${unsure > 0 ? `, ${unsure} Unsure` : ""}`;
  return (
    <span className={clsx("ra-beads", className)} role="img" aria-label={label}>
      {Array.from({ length: shown }, (_, index) => (
        <span key={index} className="ra-bead" data-unsure={index < hollow ? "true" : undefined} aria-hidden="true" />
      ))}
      {total > shown && <span className="ra-beads__more muted">+{total - shown}</span>}
    </span>
  );
}
